// app.js

jQuery(document).ready(function ($) {
    $(document).foundation();
    var $hero = $('.carousel-hero');
    // SLICKJS SLIDERS
    $(document).ready(function () {
        $hero.slick({
            dots: false,
            arrows: false,
            infinite: true,
            slide: 'div',
            speed: 600,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: 'linear',
        });

        var resizeTimer;

        $(window).on('resize orientationchange', function () {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function () {
                if ($hero.hasClass('slick-initialized')) {
                    $hero.slick('setPosition');
                }
            }, 150);
        });
        $('.quote-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            speed: 300,
            autoplay: true,
            autoplaySpeed: 6000,
            dots: false,
        });
        $(".content-slider").each(function () {
            var slideid = $(this).data("slideid");
            var slidesnumber = $(this).data("slidestoshow");
            var slidesscroll = $(this).data("slidestoscroll");
            var showarrows = $(this).data("arrows");
            var showdots = $(this).data("dots");
            $('.c-slider-' + slideid).slick({
                slidesToShow: slidesnumber,
                slidesToScroll: slidesscroll,
                arrows: showarrows,
                fade: false,
                speed: 300,
                autoplay: true,
                autoplaySpeed: 6000,
                dots: showdots,
            });
        });
        $('.gallery-photo').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 6000,
            asNavFor: '.gallery-thumb'
        });
        $('.gallery-thumb').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.gallery-photo',
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                    }
                }
            ]
        });
        $('.featured-project-slider').each(function () {
            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 800,
                fade: true,
                arrows: false,
                dots: false,
                pauseOnHover: false
            });
        });
    });

    // animated hero effect
    // document.addEventListener('scroll', () => {
    //     const heroSlides = document.querySelectorAll('.slick-slide');
    //     const scrolled = window.scrollY;
    //
    //     heroSlides.forEach(slide => {
    //         const img = slide.querySelector('picture, img');
    //         if (img) {
    //             // adjust scale based on scroll distance (0.95 = 95%)
    //             let scale = Math.max(0.85, 1 - scrolled * 0.0005);
    //             img.style.transform = `translate(-50%, -50%) scale(${scale})`;
    //         }
    //     });
    // });

    $(document).on('open.zf.reveal', '[data-reveal]', function () {
        $(window).trigger('resize');
    });

    // PORTFOLIO PROJECT FILTERS
    // This file is enqueued directly and also bundled into assets/js/app.js, so bind once.
    $(document)
        .off('click.portfolioFilter')
        .on('click.portfolioFilter', '[data-portfolio-projects] [data-filter]', function () {
            var $button = $(this);
            var filter = $button.data('filter');
            var $module = $button.closest('[data-portfolio-projects]');

            $module.find('[data-filter]').removeClass('is-active').attr('aria-pressed', 'false');
            $button.addClass('is-active').attr('aria-pressed', 'true');

            $module.find('[data-project-status]').each(function () {
                var $card = $(this);
                $card.toggleClass('hide', filter !== 'all' && $card.data('project-status') !== filter);
            });

            $(window).trigger('resize');
        });

    // LOGO GRID ROTATOR
    $(window).on('load', function () {
        if (window.Modernizr) {
            $('#ri-grid').gridrotator({
                rows: 2,
                columns: 4,
                maxStep: 1,
                interval: 3000,
                w1024: {
                    rows: 2,
                    columns: 4
                },
                w768: {
                    rows: 2,
                    columns: 3
                },
                w480: {
                    rows: 2,
                    columns: 3
                },
                w320: {
                    rows: 2,
                    columns: 3
                },
                w240: {
                    rows: 2,
                    columns: 3
                },
                animType: 'fadeInOut'
                // preventClick: false

            });
        }
    });
    ;

    // ANIMATION Slide graphics on scroll with .amimate
    $(window).scroll(function () {
        $(".animate").each(function () {
            var imagePos = $(this).offset().top;
            var topOfWindow = $(window).scrollTop();
            var halfWindow = $(window).height() * 0.5;
            var threeQuaterWindow = $(window).height() * 0.9;
            // console.log('Image position =' + imagePos + ' Top of Window =' + topOfWindow + 'halfWindow = ' + halfWindow);
            if (imagePos < topOfWindow + threeQuaterWindow) {
                $(this).addClass("slideUp");
            }
            if (imagePos > topOfWindow + threeQuaterWindow) {
                $(this).removeClass("slideUp");
            }
        }, (window.Modernizr && window.Modernizr.passiveeventlisteners) ? {passive: true} : false);
    });
    // READ MORE TOGGLE FOR TEXT MODULE
    $(document).ready(function () {
        $(".more-text-module").each(function () {
            var moretextId = $(this).data("moretextid");
            $('#more-less-button_' + moretextId).click(function () {
                console.log('clicked' + moretextId);
                $('#more-text_' + moretextId).slideToggle();
                if ($('#more-less-button_' + moretextId).text() === "Read More +") {
                    $(this).text("Read Less -")
                } else {
                    $(this).text("Read More +")
                }
            });
        });
    });


    // VIDEO PLAYER FOR YOUTUBE OR VIMEO
    $(document).ready(function () {
        $('.VideoPlayButton.vimeo').click(function () {
            var videoId = $(this).data('videoid');
            $(this).fadeOut(300, function () {
                $('#VideoContainer_' + videoId).fadeIn(300, function () {
                    $('#VideoFrame_' + videoId).attr('src', 'https://player.vimeo.com/video/' + videoId + '?color=ffffff&byline=0&portrait=0&autoplay=1');
                });

            });
        });
    });
    $(document).ready(function () {
        $('.VideoPlayButton.youtube').click(function () {
            var videoId = $(this).data('videoid');
            $(this).fadeOut(300, function () {
                $('#VideoContainer_' + videoId).fadeIn(300, function () {
                    $('#VideoFrame_' + videoId).attr('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1');
                });
            });
        });
    });
});

// Fancybox Image Gallery
document.addEventListener("DOMContentLoaded", function () {
    function waitForFancybox(attempts = 0) {
        if (window.Fancybox && typeof window.Fancybox.bind === 'function') {
            console.log("✅ Fancybox available, binding...");
            Fancybox.bind("[data-fancybox]", {
                groupAll: true,
                animated: true,
            });
        } else if (attempts < 10) {
            console.log("⏳ Waiting for Fancybox...");
            setTimeout(() => waitForFancybox(attempts + 1), 100);
        } else {
            console.warn("❌ Fancybox not found after 1s");
        }
    }

    waitForFancybox();
});

const isSmall = () => window.innerWidth < 640;

(() => {
    const getSelector = () => {
        if (isSmall()) {
            return '.rellax:not(.rellax-disable-small), [data-rellax-speed]:not(.rellax-disable-small)';
        }

        return '.rellax, [data-rellax-speed]';
    };

    let rx = null;

    const imagesReady = async (scope = document) => {
        const imgs = [...scope.querySelectorAll('img')];

        await Promise.all(imgs.map(img => {
            if (img.decode) return img.decode().catch(() => {});
            if (img.complete) return Promise.resolve();

            return new Promise(res => {
                img.addEventListener('load', res, { once: true });
            });
        }));
    };

    async function initRellax() {
        const selector = getSelector();

        if (rx || typeof Rellax !== 'function' || !document.querySelector(selector)) return;

        if (document.fonts && document.fonts.ready) {
            try { await document.fonts.ready; } catch (e) {}
        }

        await imagesReady(document);

        rx = new Rellax(selector, {
            center: true,
            round: true,
            breakpoints: [639, 1023, 1200]
        });

        requestAnimationFrame(() => rx && rx.refresh());
    }

    window.addEventListener('load', initRellax);

    document.addEventListener('replaced.zf.interchange', () => rx && rx.refresh());
    document.addEventListener('change.zf.tabs', () => rx && rx.refresh());
    document.addEventListener('opened.zf.accordion', () => rx && rx.refresh());

    let t;
    let wasSmall = isSmall();

    window.addEventListener('resize', () => {
        clearTimeout(t);

        t = setTimeout(() => {
            const nowSmall = isSmall();

            if (nowSmall !== wasSmall) {
                wasSmall = nowSmall;

                if (rx) {
                    rx.destroy();
                    rx = null;
                }

                initRellax();
                return;
            }

            if (rx) {
                rx.refresh();
            }
        }, 120);
    });
})();